import { render, staticRenderFns } from "./transition-height.vue?vue&type=template&id=cb28d5f2&scoped=true&"
import script from "./transition-height.vue?vue&type=script&lang=js&"
export * from "./transition-height.vue?vue&type=script&lang=js&"
import style0 from "./transition-height.vue?vue&type=style&index=0&id=cb28d5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb28d5f2",
  null
  
)

export default component.exports